/* eslint-disable no-unused-vars */
import 'lazysizes';
import { gsap } from 'gsap';
import InfiniteScroll from './components/infiniteScroll';
import Modal from './components/modal';
// import AjaxNavigation from './components/ajaxNavigation';
import Slider from './components/slider';
import Loader from './components/loader';
import Split from './components/split';
import Toggle from './components/toggle';
// import SmoothScroll from './components/smoothScroll';
import Animations from './components/animations';
import Countdown from './components/countdown';

// import Cursor from './components/cursor';
// import Search from './components/search';
// import Magnet from './components/magnet';
// import Billing from './components/billing';
// import GdprCompliance from './components/gdprCompliance';
import videoModal from './components/videoModal.js';
import videoModalAutoplay from './components/videoModalAutoplay.js';
import websiteMessage from './components/websiteMessage.js';
import websiteMessageAdditional from './components/websiteMessageAdditional.js';



//import Parallax from './components/parallax';

const infiniteScroll = new InfiniteScroll();
const loader = new Loader();
const modal = new Modal();
// const ajaxNavigation = new AjaxNavigation();
const sliderPrimary = new Slider('.js-slider-primary');
const split = new Split();
const toggle = new Toggle();
// const billing = new Billing();
// const smoothScroll = new SmoothScroll();
const animations = new Animations();
const countdown = new Countdown();

// const cursor = new Cursor();
// const search = new Search();
// const magnet = new Magnet();
// const gdprCompliance = new GdprCompliance();
const videomodal = new videoModal();
const videomodalautoplay = new videoModalAutoplay();

const websitemessage = new websiteMessage();
const websitemessageadditional = new websiteMessageAdditional();



//const parallax = new Parallax();

const sliderGallery = new Slider('.js-slider-gallery', {
	direction: 'horizontal',
	loop: false,
	effect: 'slide',
	speed: 1000,
	autoHeight: false,
	parallax: true,
	autoplay: false,
	slidesPerView: 1,
	spaceBetween: 40,
	breakpoints: {
		// when window width is >= xl
		1440: {
			speed: 1400,
			spaceBetween: 80,
		},
	},
});


const sliderCarousel = new Slider('.js-carousel', {
	loop: false,
	autoHeight: false,
	effect: 'slide',
	slidesPerView: 'auto',
	spaceBetween: 30,
	parallax: false,
	autoplay: false,
	freeMode: false,
	speed: 300,
	touchEventsTarget: '.swiper-wrapper',
	pagination: {
		el: '.swiper-pagination',
		type: 'progressbar',
	},
	// when window width is >= xl
	1440: {
		freeMode: true,
		speed: 1400,
	},
});


const carousel = new Slider('.js-gallery', {
	loop: false,
	autoHeight: false,
	effect: 'slide',
	slidesPerView: 1,
	spaceBetween: 0,
	parallax: false,
	autoplay: true,
	speed: 300,
	allowTouchMove: false,
	pagination: {
        el: '.swiper-pagination',
    },
});